import { getUser, logger, refreshToken } from '@/api';
import localCache from '@/utils/localCache';

const [, user_id] = window.location.pathname.split('/');

const state = {
  info: {},
  isFetch: false,
  access_token: localCache.getItem(`${user_id}-access_token`) || '',
  refresh_token: localCache.getItem(`${user_id}-refresh_token`) || ''
};
const mutations = {
  ADD_USER: (state, playload) => {
    state.info = Object.freeze({ ...playload });
  },
  SET_AUTH: (state, { refresh_token, access_token }) => {
    state.refresh_token = refresh_token;
    state.access_token = access_token;
    localCache.setItem(`${state.info.id}-refresh_token`, refresh_token);
    localCache.setItem(`${state.info.id}-access_token`, access_token);
  },
  LOGOUT: state => {
    localCache.removeItem(`${state.info.id}-access_token`);
    localCache.removeItem(`${state.info.id}-refresh_token`);
    localStorage.removeItem('token');
    localStorage.removeItem('clientId');
    state.access_token = '';
    state.refresh_token = '';
    // 获取当前域名下的所有cookie
    const cookies = document.cookie.split(';');
    // 遍历所有cookie，并设置过期时间以删除它们
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }

    window.location.replace('/login');
  },
  FETCH_STATE: (state, playload) => {
    state.isFetch = !!playload;
  }
};

const actions = {
  async addUser({ commit, state }, playload) {
    if (playload && playload.id) {
      commit('ADD_USER', playload);
      return playload;
    }
    if ((playload && playload.isRefresh) || !state.info.id) {
      const res = await getUser({
        access_token: playload ? playload.access_token : ''
      });
      if (res && res.data) {
        commit('ADD_USER', res.data.user);
        return res.data.user;
      }
    }
    return state.info;
  },
  setAuth({ commit, state, dispatch }, playload) {
    return new Promise((resolve, reject) => {
      if (playload && playload.access_token) {
        dispatch('addUser', playload)
          .then(() => {
            commit('SET_AUTH', playload);
            resolve(playload);
          })
          .catch(e => reject(e));
      } else if (!state.isFetch) {
        commit('FETCH_STATE', true);
        refreshToken({ refresh_token: state.refresh_token })
          .then(req => {
            commit('FETCH_STATE', false);
            if (req && req.data) {
              const access_token = req.data.new_access_token;
              dispatch('addUser', { access_token })
                .then(() => {
                  commit('SET_AUTH', {
                    access_token,
                    refresh_token: state.refresh_token
                  });
                  resolve(req.data);
                })
                .catch(e => reject(e));
            } else {
              dispatch('msg/showErrorMsg', req.msg || '登录过期，请重新登录', { root: true });
              commit('LOGOUT');
              reject(req);
            }
          })
          .catch(e => {
            commit('FETCH_STATE', false);
            dispatch('msg/showErrorMsg', e.toString() || '未知异常，请重新登录', { root: true });
            commit('LOGOUT');
            reject(e);
          });
      } else {
        reject(state);
      }
    });
  },
  async logout({ commit }) {
    commit('LOGOUT');
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
